import { Typography } from '@mui/material';

interface IdentifierProps {
  name?: string;
  coordinate?: string;
}

export default function NamedCoordinateDescription({ name = '', coordinate = '' }: IdentifierProps): React.JSX.Element {
  return <Typography color={'textSecondary'}>{name + (coordinate !== '' ? '@' + coordinate : '')}</Typography>;
}
